
import {
  ConfigurableProductOptionsValues,
  ConfigurableVariant,
  Maybe
} from "@/types/graphql.prod"

// 过滤掉不存在的values---color
const getFilterValuesColor = ({
  values,
  variants,
  attribute_code // color
}:{
    values: Maybe<ConfigurableProductOptionsValues>[]
    variants: Maybe<ConfigurableVariant>[]
    attribute_code: string
}) => {
  const tempArray: ConfigurableProductOptionsValues[] = []


  values?.forEach((item) => {
    const find = variants.find((temp) => {
      return temp?.attributes?.some((attr) => attr?.code === attribute_code &&
                        attr?.value_index === item?.value_index)
    })

    if (find && item) {
      tempArray.push(item)
    }
  })

  return tempArray
}

// 找到当前 color 的所有 variants
const findVariants = ({
  item_value_index,
  variants
}:{
    item_value_index: number
    variants: Maybe<Maybe<ConfigurableVariant>[]> | undefined,
}) => {
  const match = variants?.filter((variant) => {
    const {
      attributes 
    } = variant || {}
    const {
      value_index: variant_value_index 
    } = attributes?.[0] || {}

    return variant_value_index === item_value_index
  })

  return match?.[0]
}

const getStatus = (match: Maybe<ConfigurableVariant> | undefined) => {

  if (!match) {
    return ""
  }

  const product = match?.product 
  const {
    stock_status, presale_product 
  } = product || {}
  const {
    status: isPreOrder 
  } = presale_product || {}

  if (isPreOrder) {
    return "PREORDER"
  }

  if (stock_status === "IN_STOCK") {
    return stock_status
  }

  return stock_status
}

export const getSortedColor = ({
  values,
  variants,
  attribute_code
}:{
    values: Maybe<Maybe<ConfigurableProductOptionsValues>[]> | undefined
    variants: Maybe<Maybe<ConfigurableVariant>[]> | undefined,
    attribute_code: string
}) => {

  if (!values) { return [] }

  if (!variants) { return [] }

  const instockArray: ConfigurableProductOptionsValues[] = []
  const outofStockArray: ConfigurableProductOptionsValues[] = []
  const preOrderArray: ConfigurableProductOptionsValues[] = []

  const filterValuesColor = getFilterValuesColor({
    values,
    variants,
    attribute_code
  })

  filterValuesColor.forEach((item) => {
    const {
      value_index: item_value_index 
    } = item || {}

    if (!item_value_index) {
      return []
    }
  
    const match = findVariants({
      item_value_index: item_value_index,
      variants
    })

    const status = getStatus(match)

    if (status === "PREORDER") {
      preOrderArray.push(item)

      return
    }

    if (status === "IN_STOCK") {
      instockArray.push(item)

      return
    }

    outofStockArray.push(item)
  })

  return [...instockArray, ...preOrderArray, ...outofStockArray]
}
